import onClickOutside from 'react-onclickoutside'

import TargetWord from './target_sentence/TargetWord'
import Segmenter  from './../helpers/Segmenter'

class TargetSentence extends React.PureComponent
  constructor: (props) ->
    super(props)

    @highlightSentence   = @highlightSentence.bind(this)
    @unhighlightSentence = @unhighlightSentence.bind(this)

  handleClickOutside: (e) ->
    # Important: ALL target sentences have this handler, so it is triggered as many times as there are target sentences
    # The ONLY case we want to handle is when one of the words in THIS current sentence is active (meaning that its alternative dropdown is open)
    # We know the alternative dropdown is open ONLY if (see the "active" prop we pass to TargetWord))
    # - the current sentence is active
    # - AND @props.activeWordIndex has a value (not -1)
    if @props.active && @props.activeWordIndex != -1
      @props.setActiveSentence(-1)
      @props.setActiveWord(-1)

  highlightSentence: ->
    # Highlight active sentence on mouseEnter only if no active word (and sentence already highlighted somewhere)
    if @props.activeWordIndex == -1
      @props.setActiveSentence(@props.index)

  unhighlightSentence: ->
    # Unhighlight active sentence on mouseLeave only if no active word (and sentence already highlighted somewhere)
    if @props.activeWordIndex == -1
      @props.setActiveSentence(-1) # no more active sentence

  splitSentenceToParts: ->
    if !@props.proofreading # No proofreading = no diff ! Array with only 1 string for the whole sentence
      [@props.sentence]
    else # Detect "diff" parts when proofreading
      diffs = diffWords(@props.sourceSentence, @props.sentence, { intlSegmenter: @props.intlSegmenter })

      diffs.map((part) ->
        if part.added
          [part.value]
        else if !part.removed
          part.value
      ).filter(Boolean) # like `.compact`

  render: ->
    # 1. Split sentence to highlight "diff" parts (when proofreading mode).
    # => ['Hello', ['lovely and nice'], 'people'] => "lovely and nice" is highlighted diff (array)!
    # => ['Hello lovely and nice people']         => No diff (no array)
    sentenceParts = @splitSentenceToParts()
    globalIndex   = 0

    # 2. Build sentence parts
    renderedSentence = sentenceParts.map((sentencePart, partIndex) =>
      isHighlightedDiff = Array.isArray(sentencePart)
      sentencePart      = sentencePart[0] if isHighlightedDiff

      if @props.loading && !@props.active
        renderedWords = sentencePart # Optimization: no need to split words (in sentences or diffs) when translation is loading! (lots of re-renderings!)
      else
        words         = Segmenter.words(sentencePart, @props.languageCode, { intlSegmenter: @props.intlSegmenter })
        renderedWords = words.map((word, index) => @renderWord(word, globalIndex + index))
        globalIndex   += words.length

      if isHighlightedDiff
        <span className="diff"
              key="#{partIndex}-#{sentencePart}">
          {renderedWords}
        </span>
      else
        renderedWords
    )

    # 3. Render final component
    classes = 'sentence'
    classes += ' active' if @props.active

    # OnClick when clicking on another sentence during word_alternative selection (no mouseEnter in this case)
    <span className={classes}
          onMouseEnter={@highlightSentence}
          onClick={@highlightSentence}
          onMouseLeave={@unhighlightSentence}>
      {renderedSentence}
    </span>

  renderWord: (word, wordIndex) ->
    <TargetWord key="#{wordIndex}-#{word}"
                word={word}
                index={wordIndex}
                sentenceIndex={@props.index}
                active={@props.active && @props.activeWordIndex == wordIndex}
                direction={@props.direction}
                wordAlternatives={@props.wordAlternatives}
                wordAlternativesLoading={@props.wordAlternativesLoading}
                setActiveSentence={@props.setActiveSentence}
                setActiveWord={@props.setActiveWord}
                selectWordAlternative={@props.selectWordAlternative} />

export default onClickOutside(TargetSentence)
